const getInitials = name => {
  if (typeof name !== "string" || !name) return null;

  const parts = name.toUpperCase().split(" ");

  const [firstName, lastName] = parts;

  return firstName && lastName ? `${firstName[0]}${lastName[0]}` : `${firstName[0]}${firstName[1]}`;
};

const agentAdapter = agent => {
  if (!agent) return null;

  return {
    mandatedTo: agent.name,
    tinNumber: agent.code,
    address: agent.address?.street,
    mandatedBy: agent.mandatedBy,
    mandatedToInitials: getInitials(agent.mandatedBy),
    mandatedByCustomerCode: agent.mandatedByCustomerCode,
    mandatedByCustomerName: agent.mandatedByCustomerName,
    on: new Date(agent.mandatedAt)
  };
};

export { agentAdapter };
